import React, { Component } from 'react'
import { Formik, ErrorMessage } from 'formik'
import { Form, Field } from 'formik-antd'
import validate from './validation/templateForm'

export default class TemplateForm extends Component {
    state = {
        value: '',
        textLength: 0,
    }

    onTemplateChange = value => {
        this.setState({ value, textLength: value.length })
    }

    handleFormSubmit = (data, setSubmitting) => {
        const { id } = data

        if (id) {
            this.props.actions
                .updateTemplate(data)
                .then(res => this.props.handleClose())
                .catch(error => {
                    console.log(`error=${error}`)
                })
                .finally(() => {
                    setSubmitting(false)
                })
        } else {
            this.props.actions
                .addTemplate(data)
                .then(res => this.props.handleClose())
                .catch(error => {
                    console.log(`error=${error}`)
                })
                .finally(() => {
                    setSubmitting(false)
                })
        }
    }

    render() {
        const empty = {
            
            name: '',
            body: '',
        }

        const selectedTemplate = this.props.data
        const initialValues = selectedTemplate ? selectedTemplate : empty

        return (
            <Formik
                initialValues={initialValues}
                validate={validate()}
                onSubmit={(values, { setSubmitting }) => {
                    setTimeout(() => {
                        this.handleFormSubmit(values, setSubmitting)
                    }, 400)
                }}
            >
                {subForm => (
                    <Form>
                        <div>
                            <div className="modal-body">
                                <div className="container-fluid">
                                    <div className="row form-group">
                                        <label className="col-xs-3  col-sm-3 col-md-3 control-label">
                                            Template Name
                                        </label>
                                        <div className="col-xs-9 col-sm-9 col-md-9">
                                            <Field
                                                id="name"
                                                name="name"
                                                type="text"
                                                className="form-control"
                                                placeholder="Template Name"
                                                maxLength="30"
                                                onChange={subForm.handleChange}
                                                onBlur={subForm.handleBlur}
                                                value={subForm.values.name}
                                            />
                                            <div className="errorMsg">
                                                <ErrorMessage name="name" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className=" col-sm-12 form-group5">
                                            <label className="col-xs-3 col-sm-3 col-md-3 control-label">
                                                Template Body
                                            </label>
                                            <div className="col-xs-9 col-sm-9 col-md-9">
                                                <textarea
                                                    id="body"
                                                    type="text"
                                                    className="form-control textarea-size"
                                                    placeholder="Template body"
                                                    value={subForm.values.body}
                                                    rows="5"
                                                    maxLength="160"
                                                    onChange={e => {
                                                        subForm.setFieldValue(
                                                            'body',
                                                            e.target.value
                                                        )
                                                        this.onTemplateChange(
                                                            e.target.value
                                                        )
                                                    }}
                                                    onBlur={subForm.handleBlur}
                                                />

                                                <p className="help-block ">
                                                    Approx.{' '}
                                                    {this.state.textLength}{' '}
                                                    characters
                                                </p>
                                                <div className="errorMsg">
                                                    <ErrorMessage name="body" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="modal-footer">
                                <button
                                    type="submit"
                                    className="btn btn-default"
                                    data-dismiss="modal"
                                    disabled={subForm.isSubmitting}
                                    onClick={this.props.handleClose}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-success"
                                    disabled={subForm.isSubmitting}
                                    onClick={() => {
                                        subForm.submitForm()
                                    }}
                                >
                                    Save
                                </button>
                            </div>
                        </div>
                    </Form>
                )}
            </Formik>
        )
    }
}
